export const TERMS_URL = '/terms_and_conditions'
export const BUSINESS_TERMS_URL = '/pro-terms-of-use'
export const OUR_PLATFORM_URL = '/our-platform'
export const APP_LANDING_URL = '/app'
export const PRIVACY_POLICY_URL = '/privacy-policy'
export const COOKIE_POLICY_URL = '/cookie-policy'
export const BUSINESS_TERMS_AND_CONDITIONS_URL = '/pro-terms-and-conditions'
export const BUSINESS_TERMS_OF_SALE_URL = '/pro-terms-of-sale'
export const BUSINESS_ACCOUNTS_HOMEPAGE = '/pro'
export const BUSINESS_ACCOUNTS_GUIDE_URL = '/pro-guide'
export const MAIN_NAVIGATION_ABOUT_TAB_URL = '/about'
export const SOCIAL_FACEBOOK_URL = 'https://www.facebook.com/vinted'
export const SOCIAL_LINKEDIN_URL = 'https://www.linkedin.com/company/vinted'
export const SOCIAL_INSTAGRAM_URL = 'https://www.instagram.com/vinted'
export const HELP_CENTER_URL = '/help'
export const HELP_SELLING_URL = '/help/4-selling?access_channel=hc_topics'
export const HELP_BUYING_URL = '/help/5-buying?access_channel=hc_topics'
export const HELP_SAFETY_URL = '/safety'
export const HOW_IT_WORKS_URL = '/how_it_works'
export const INFOBOARD_URL = '/infoboard'
export const ITEM_VERIFICATION_URL = '/item_verification'
export const ADVERTISING_URL = '/advertising'
export const JOBS_URL_NEW = 'https://careers.vinted.com/'
export const JOBS_URL = '/jobs'
export const PRESS_CENTER_URL = 'https://company.vinted.com'
export const ACCESSIBILITY_URL = '/accessibility'
